export const servicesSections = [
  // 1️⃣ Світла класична секція з іконками
  `<section class="py-5 bg-light text-center">
    <div class="container">
      <h2 class="fw-bold mb-4 text-dark">Наші послуги</h2>
      <div class="row g-4 justify-content-center">
        <div class="col-md-3">
          <i class="bi bi-gear fs-1 text-primary mb-3"></i>
          <h5 class="fw-bold">Автоматизація</h5>
          <p class="text-muted">Ми оптимізуємо ваші процеси за допомогою сучасних технологій.</p>
        </div>
        <div class="col-md-3">
          <i class="bi bi-shield-check fs-1 text-success mb-3"></i>
          <h5 class="fw-bold">Безпека</h5>
          <p class="text-muted">Захищаємо ваші дані на кожному етапі роботи.</p>
        </div>
        <div class="col-md-3">
          <i class="bi bi-lightning-charge fs-1 text-warning mb-3"></i>
          <h5 class="fw-bold">Ефективність</h5>
          <p class="text-muted">Скорочуємо час виконання завдань і підвищуємо результат.</p>
        </div>
      </div>
    </div>
  </section>`,

  // 2️⃣ Темна секція з контрастом і центром
  `<section class="py-5 bg-dark text-white text-center">
    <div class="container">
      <h2 class="fw-bold mb-4">Що ми робимо</h2>
      <div class="row justify-content-center g-4">
        <div class="col-md-4">
          <h5 class="fw-bold text-info">Аналітика</h5>
          <p class="text-light">Збираємо та структуруємо дані для точних рішень.</p>
        </div>
        <div class="col-md-4">
          <h5 class="fw-bold text-warning">Консалтинг</h5>
          <p class="text-light">Допомагаємо побачити сильні сторони вашого бізнесу.</p>
        </div>
        <div class="col-md-4">
          <h5 class="fw-bold text-success">Супровід</h5>
          <p class="text-light">Постійна підтримка на всіх етапах співпраці.</p>
        </div>
      </div>
    </div>
  </section>`,

  // 3️⃣ Кольоровий фон із чергуванням колонок
  `<section class="py-5 bg-primary bg-opacity-10">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start">
          <h2 class="fw-bold mb-4 text-primary">Комплексні рішення</h2>
          <p class="text-secondary mb-4">Наші сервіси охоплюють усі етапи цифрової трансформації — від аудиту до впровадження.</p>
          <a href="#" class="btn btn-primary px-4">Дізнатись більше</a>
        </div>
        <div class="col-md-6">
          <ul class="list-group list-group-flush">
            <li class="list-group-item bg-transparent"><i class="bi bi-check-circle text-primary me-2"></i> Аналіз бізнес-процесів</li>
            <li class="list-group-item bg-transparent"><i class="bi bi-check-circle text-primary me-2"></i> Технічна інтеграція</li>
            <li class="list-group-item bg-transparent"><i class="bi bi-check-circle text-primary me-2"></i> Навчання команди</li>
          </ul>
        </div>
      </div>
    </div>
  </section>`,

  // 4️⃣ Центрована секція з великими іконками і кольоровим бекграундом
  `<section class="py-5 bg-success bg-opacity-10 text-center">
    <div class="container">
      <h2 class="fw-bold text-success mb-5">Наш підхід</h2>
      <div class="row g-5 justify-content-center">
        <div class="col-md-3">
          <i class="bi bi-diagram-3 fs-1 text-success mb-3"></i>
          <h5 class="fw-bold">Структурність</h5>
          <p class="text-muted">Ми будуємо логічну архітектуру кожного рішення.</p>
        </div>
        <div class="col-md-3">
          <i class="bi bi-people fs-1 text-success mb-3"></i>
          <h5 class="fw-bold">Взаємодія</h5>
          <p class="text-muted">Комунікація з клієнтом — ключ до результату.</p>
        </div>
        <div class="col-md-3">
          <i class="bi bi-bar-chart fs-1 text-success mb-3"></i>
          <h5 class="fw-bold">Розвиток</h5>
          <p class="text-muted">Постійне вдосконалення систем і процесів.</p>
        </div>
      </div>
    </div>
  </section>`,

  // 5️⃣ Мінімалістична секція з лівим вирівнюванням
  `<section class="py-5 bg-white">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <h2 class="fw-bold mb-4 text-dark">Сервіси для зростання</h2>
          <p class="text-secondary">Ми розробляємо сервіси, які допомагають вашому бізнесу працювати швидше, простіше та результативніше. Кожне рішення базується на досвіді, аналітиці та здоровій логіці.</p>
          <ul class="mt-4 text-secondary">
            <li>✔ Бізнес-оптимізація</li>
            <li>✔ Автоматизація операцій</li>
            <li>✔ Технічний аудит</li>
          </ul>
        </div>
      </div>
    </div>
  </section>`,
];
